import type { IconSvgObject } from './types';

const LayoutTable02Icon: IconSvgObject = [
  ["path", { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 21.5V2.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21.4999 8H2.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21.4999 16H2.5", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default LayoutTable02Icon;
